import React from 'react'
import { ClassroomManager } from '@helpers'

import Note from '../Note'
import Sketch from '../Sketch'
import Code from '../Code'
import Finder from '../Finder'
import { useClassroomQuery } from '../../hooks'

const Panel = ({ type }) => {
  const {
    data: { participants = {} }
  } = useClassroomQuery()

  return (
    <div className={`gp-classroom-component-wrapper`}>
      {type === 'sketch' && (
        <Sketch close={() => ClassroomManager.closePanel('sketch')} />
      )}

      {type === 'note' && (
        <Note close={() => ClassroomManager.closePanel('note')} />
      )}
      {type === 'code' && (
        <Code close={() => ClassroomManager.closePanel('code')} />
      )}
      {type === 'finder' && (
        <Finder
          participants={participants}
          close={() => ClassroomManager.closePanel('finder')}
        />
      )}
    </div>
  )
}

export default Panel
